import React from 'react';
import CircularCarouselBrands from '../CircularCarousel/CircularCarouselBrands';
import { css } from '@emotion/core';
import Link from '../../../shared/Link/Link';

import './ModuleBrandsCarousel.scss';
import { ImageDispatcher } from '../../../shared/ImageDispatcher/ImageDispatcher';

const ModuleBrandsCarousel = ({
  primaryColor,
  secondaryColor,
  circularCarouselImages,
  circularCarouselVersion,
  coloredBackgroundCircularCarousel,
  brandsCarouselTitle,
  sliderCircleArrowsBrands,
  isMobile,
}) => {
  const images = (circularCarouselImages || []).filter(
    item => !!item.publishFarmakom
  );

  const actualBrandArrayLength = images.length;

  const containerVariants = css`
    & .title-container h2 {
      font-size: 22px;
      font-weight: 600;
    }
    &.centered {
      padding-right: 3% !important;
      padding-left: 3% !important;
    }

    & .slick-slider {
      margin: 0 12px;

      & .slick-list {
        margin-left: ${actualBrandArrayLength < 8 ? '0px' : '17px'};
        margin-right: ${actualBrandArrayLength < 8 ? '36px' : '14px'};
        & .slick-track {
          @media screen and (min-width: 1300px) {
            margin-left: unset !important;
          }
        }
      }
      & .slick-arrow.slick-prev {
        left: ${circularCarouselVersion === 1 ? '-1%' : '-2%'};
      }
      & .slick-arrow.slick-next {
        right: ${circularCarouselVersion === 1 ? '0%' : '-0.5%'};
      }
    }

    &.colored-bg {
      background-color: #f8f8f8;

      @media screen and (max-width: 768px) {
        padding: 2rem 1rem !important;
      }
      @media screen and (min-width: 769px) {
        padding: ${circularCarouselVersion !== 3
          ? '28px 40px 28px 40px !important'
          : '28px 50px 28px 50px !important'};
      }
      border-radius: 6px;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
  `;

  const renderCircularCarousel = () => {
    if (isMobile) {
      return renderCircularCarouselMobile();
    } else {
      return renderCirularCarouselDesktop();
    }
  };

  const renderCirularCarouselDesktop = () => {
    return (
      <div className="hidden-mobile">
        <CircularCarouselBrands
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          circularCarouselImages={circularCarouselImages}
          circularCarouselVersion={circularCarouselVersion}
          coloredBackgroundCircularCarousel={coloredBackgroundCircularCarousel}
          brandsCarouselTitle={brandsCarouselTitle}
          sliderCircleArrowsBrands={sliderCircleArrowsBrands}
          containerVariants={containerVariants}
        />
      </div>
    );
  };

  const renderCircularCarouselMobile = () => {
    return (
      <div className="hidden-desktop">
        <div
          className={`${
            coloredBackgroundCircularCarousel === 1 ? 'colored-bg' : ''
          } ${circularCarouselVersion === 1 ? 'container' : ''}`}
          css={containerVariants}
        >
          <div style={{ margin: '0 0 1rem 0' }}>
            <h2 style={{ fontSize: 20, fontWeight: 500, marginBottom: 0 }}>
              {brandsCarouselTitle}
            </h2>
          </div>
          <div className="circular-carousel-container">
            {images.map((item, index) => (
              <div className="frame" style={{}}>
                <Link to={'/brand/' + item.seoName}>
                  <ImageDispatcher
                    src={item.logoImage}
                    alt={`Logo relativo al brand ${item.seoName}`}
                    className={`img-fluid ${index >= 3 ? 'lazyload' : ''}`}
                    style={{ width: '100%' }}
                  />
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  };

  return <>{renderCircularCarousel()}</>;
};
export default ModuleBrandsCarousel;
